/**
 * Blueprint for the modal options
 */
export class ModalOptions {
  public title: string;
  public paragraph: string;
  public submitText: string;
  public cancelText: string;

  constructor(title: string, paragraph: string, submitText: string, cancelText: string) {
    this.title = title;
    this.paragraph = paragraph;
    this.submitText = submitText;
    this.cancelText = cancelText;
  }
}
